import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'babel-polyfill';
import tinymce from 'tinymce'
import VueTinymce from '@packy-tang/vue-tinymce'

// style
import './assets/style/element-variables.scss'
import './assets/style/public.scss'
import './assets/style/layout.scss'

Vue.use(VueTinymce)

// element-ui

import Element from 'element-ui'
import  'element-ui/lib/theme-chalk/index.css'
Vue.use(Element)
Vue.prototype.$tinymce = tinymce

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
